import { Routes, Route, Navigate } from 'react-router-dom';
import appInfo from './app-info';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';
import { Footer } from './components';
import { InvitoPage } from './pages';
import TenantProvider from './contexts/TenantProvider';
import routes from './app-routes';

export default function Content() {

  return (
    <Routes>
      <Route path="/invite" element={<InvitoPage />} />

      <Route element={<Layout />}>
        {routes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={element}
          />
        ))}

        <Route
          path='*'
          element={<Navigate to='/home' />}
        />
      </Route>
    </Routes>
  );
}

export function Layout({ children }: { children?: React.ReactNode }) {
  return (
    <TenantProvider>
      <SideNavBarLayout>
        {children}
      </SideNavBarLayout>
    </TenantProvider>
  );
}
